import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Start from "./Start";

function App() {
  return <Start />;
}

export default App;
